export enum ThreadStatusEnum {
  CREATED = 'CREATED',
  ASSIGNED = 'ASSIGNED',
  ACCEPTED = 'ACCEPTED',
  PAUSED = 'PAUSED',
  CLOSED = 'CLOSED'
}
